// extracted by mini-css-extract-plugin
module.exports = {"container":"CogOptions_container__Qp2ZW","loading":"CogOptions_loading__1Cyh4","dots":"CogOptions_dots__2zqhb"};